/* ============
 * Login User
 * ============
 *
 * This is the page for logging user in.
 */

import { mapGetters } from 'vuex';
import auth from './../../../services/auth';
import Forms from './../../../utils/forms/forms';

export default {
  data() {
    return {
      form: new Forms({
        email: {
          value: '',
          type: 'email',
        },
        password: {
          value: '',
          type: 'password',
        },
      }),
    };
  },

  computed: {
    ...mapGetters({
      maintenance: 'isInMaintenance',
    }),
  },

  created() {
  },

  methods: {
    /**
     * Logs the user in
     */
    login() {
      this.form.loading = true;
      this.form.errorBox = false;
      auth.login(this.form.data())
      .catch((errors) => {
        if (errors.error && errors.error.code === 42206) {
          this.form.errorBoxTitle = this.$t('static.login.inactiveAccount');
        } else if (errors.error && errors.error.code === 42901) {
          // Lockout error - display the message from backend which includes seconds remaining
          this.form.errorBoxTitle = errors.error.message || 'Too many login attempts. Please try again later.';
        }
        this.form.loading = false;
        this.form.errorBox = true;
        this.form.recordErrors(errors);
      });
    },
  },

  components: {
    VForm: require('./../../../components/form/form.vue'),
    VLayout: require('./../../../layouts/user/user.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/pages/auth/login/login.js